/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const cancelRoutinePendingRotationBodyExpectedVersionExclusiveMin = 0;
export const cancelRoutinePendingRotationBodyExpectedVersionMax = 9007199254740991;

export const cancelRoutinePendingRotationBodyPreviewFingerprintMax = 256;

export const cancelRoutinePendingRotationBodyConfirmNewGapsDefault = false;
export const CancelRoutinePendingRotationBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(cancelRoutinePendingRotationBodyExpectedVersionExclusiveMin)
    .max(cancelRoutinePendingRotationBodyExpectedVersionMax),
  previewFingerprint: zod
    .string()
    .min(1)
    .max(cancelRoutinePendingRotationBodyPreviewFingerprintMax),
  confirmNewGaps: zod.boolean().default(cancelRoutinePendingRotationBodyConfirmNewGapsDefault),
});

export type CancelRoutinePendingRotationBody = zod.input<typeof CancelRoutinePendingRotationBody>;
export type CancelRoutinePendingRotationBodyOutput = zod.output<
  typeof CancelRoutinePendingRotationBody
>;
